import app from '../app';
import { animateScrollTop } from '@cian/ui/app/services/dom-utils';

/* см. app/scripts/services/retry.interceptor.js */

app.factory('retryService', ['$rootScope', '$document', '$window', function($rootScope, $document, $window) {
    const events = {
        requestFailed: 'RETRY_FAIL',
        requestSuccessful: 'RETRY_SUCCESS',
        requestRepeat: 'RETRY_RUN',
        requestRepeatAlreadyInProgress: 'RETRY_RUN_PROGRESS'
    };

    const retryFailArr = [];

    const retryCodeAdd = (code) => {
        if (code === 'checkPublish' || retryFailArr.indexOf(code) !== -1) {
            return;
        }
        retryFailArr.push(code);
    };

    const retryCodeRemove = (code) => {
        const index = retryFailArr.indexOf(code);
        if (index === -1) {
            return;
        }
        retryFailArr.splice(index, 1);
    };

    const retryRun = () => {
        retryFailArr.forEach(code => {
            $rootScope.$emit(events.requestRepeat, code);
        });
    };

    $rootScope.$on(events.requestFailed, (event, shortCode) => retryCodeAdd(shortCode));
    $rootScope.$on(events.requestSuccessful, (event, shortCode) => retryCodeRemove(shortCode));

  return {
        events,
        runRetry: () => {
            try {
                const document = $document[0];
                const firstRetryBlock = document.querySelector('.js-retry-notice-modal').closest('.js-segment');
                const {clientTop} = document.documentElement;
                const {pageYOffset} = $window;
                const {top: rectTop} = firstRetryBlock.getBoundingClientRect();

                const scrollTo = pageYOffset + rectTop - clientTop;

                animateScrollTop({
                    to: scrollTo,
                    duration: 300,
                    done: () => {
                        retryRun();
                    },
                });
            } catch (e) {
                // TODO: send to sentry
                retryRun();
                throw e;
            }
        },
        showRetryNotice: () => retryFailArr.length > 0,
    }
}]);
